var normalizeLocale = function (locale) {
    return locale.replace('-', '_').toLocaleLowerCase();
};
export var compareLocales = function (locale1, locale2) {
    if (locale1 === void 0) { locale1 = ''; }
    if (locale2 === void 0) { locale2 = ''; }
    return normalizeLocale(locale1) === normalizeLocale(locale2);
};
